import PropTypes from 'prop-types';
import React from 'react';
export class FundedProjectCard extends React.PureComponent {
	constructor(props, context) {
		super(props, context);
	}

	renderMessage(thankYouMessage) {
		thankYouMessage = thankYouMessage.slice(0, thankYouMessage.search(/[\n\r]*With gratitude/))
				.replace(/[\n\r]+/g, "</p><p>");
		let maxLength = 500;

		if(thankYouMessage.length > maxLength){
			//trim the string to the maximum length
			thankYouMessage = thankYouMessage.substr(0, maxLength);

			//re-trim if we are in the middle of a word
			thankYouMessage = thankYouMessage.substr(0, thankYouMessage.lastIndexOf(" "));
			thankYouMessage += "..."
		}

		return (
				<div className="teacher-text-box">
					<div className="teacher-text">
						<p dangerouslySetInnerHTML={{__html: thankYouMessage + "&rdquo;"}}></p>
					</div>
				</div>
		);
	}

	render() {
		let project = this.props.project;
		let tyAssets = project.thankYouAssets;
		let thankYouMessage = tyAssets && (tyAssets.resultsLetter || tyAssets.interimThankYou);
		let teacherName = project.teacherName.replace(/&amp;/g, "&").replace(/&lt;/g, "<").replace(/&gt;/g, ">");

		if (!thankYouMessage) {
			return null;
		}





		return (
				<div className="teacher-quotation">
					<div className="teacher-details">
						<img src={project.teacherProfilePhotoURL} className="teacher-image"/>
						<div className="teacher-info">
							<div className="teacher-name">
								{teacherName}
							</div>
							<div className="teacher-description">
								<span dangerouslySetInnerHTML={{__html: project.schoolName}}/><span className="teacher-dot">&#8226;</span>{project.city}, {project.state}
							</div>
						</div>
					</div>
					{this.renderMessage(thankYouMessage)}
					<div className="donation-date">
						Supported <a href={project.proposalURL} dangerouslySetInnerHTML={{__html: project.title}}/> on {this.props.donationDate} {this.props.anonymous ? "(only visible to you)" : ""}
					</div>
				</div>
		);
	}
}

FundedProjectCard.propTypes = {
	project: PropTypes.object.isRequired,
	donationDate: PropTypes.string,
	anonymous: PropTypes.bool

};
